<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 280px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }

  .elmargin {
    margin-bottom: 21px;
  }
}

.tree_box {
  width: 100%;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;

  p {
    padding: 0;
    margin: 0;
    color: #666;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

.el-table {
  width: 99.9% !important;
}

.balance-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .balance-amount {
    font-size: 18px;
    font-weight: bold;
    color: #f56c6c;
  }
  
  .update-time {
    font-size: 12px;
    color: #999;
  }
}
</style>
<template>
  <div
      class="box"
      element-loading-text="正在查询，请稍候..."
  >
    <p class="page_title">部门停车费管理</p>
    <el-row :gutter="24" style="width: 100%;padding: 0;margin: 0;">
      <el-col
          :span="24"
          style="background: #fff; padding: 50px 15px; padding-top: 5px; box-sizing: border-box"
      >
        <div class="query_box">
          <el-form
              :model="form"
              ref="form"
              label-position="100px"
              size="medium"
          >
            <el-row :gutter="10">
              <el-col :span="6" class="elmargin">
                <el-input
                    v-model="form.orgName"
                    size="medium"
                    placeholder="请输入部门名称"></el-input>
              </el-col>
              <el-col :span="5">
                <el-button size="medium" type="primary" icon="el-icon-search" @click="qryInfo()">查询</el-button>
                <el-button size="medium" icon="el-icon-refresh" @click="reset()">重置</el-button>
              </el-col>
              <el-col :span="4">
                <el-button
                  size="medium"
                  type="primary"
                  icon="el-icon-edit"
                  @click="handleEditBalance"
                  :disabled="selectedDepartments.length === 0"
                >
                  编辑余额
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table_box">
          <data-table
              :columns="tableColumns"
              :data="tableData1"
              @selects="selects"
              :show-checkbox="true"
          >
            <el-table-column fixed="right" label="操作" min-width="100">
              <template slot-scope="scope">
                <el-button
                    @click="handleEditSingleBalance(scope.row)"
                    type="primary"
                    icon="el-icon-edit"
                >编辑余额
                </el-button>
              </template>
            </el-table-column>
          </data-table>
          <edit-balance-dialog
              :visible.sync="editBalanceVisible"
              :selectedDepartments="selectedDepartments"
              @success="qryInfo()"
          ></edit-balance-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import index from "@/components/mixins/index";
import DataTable from "@/components/common/DataTable.vue";
import EditBalanceDialog from "./EditBalanceDialog";
import { getParkingBalanceList } from "./api/index"
import DepartmentTree from "./component/departmentTree";

export default {
  mixins: [index],
  data() {
    return {
      form: {
        orgName: "",
      },
      tableColumns: [
        {label: "部门编码", prop: "code", minWidth: "180"},
        {label: "部门名称", prop: "name", minWidth: "150"},
        {label: "剩余费用 (元)", prop: "parkingBalance", minWidth: "120"},
      ],
      tableData1: [],
      editBalanceVisible: false,
      selectedDepartments: [],
      currentDepartmentName: null,
      currentDepartmentId: null,
    };
  },
  methods: {
    // 组织架构节点点击后的回调
    onDepartmentNodeClick(node) {
      this.currentDepartmentName = node.name
      this.currentDepartmentId = node.id
      this.qryInfo()
    },
    // 重置查询
    reset() {
      this.form.orgName = ""
      this.currentDepartmentName = null
      this.currentDepartmentId = null
      this.qryInfo()
    },
    // 处理编辑余额（批量）
    handleEditBalance() {
      if (this.selectedDepartments.length === 0) {
        this.$message.warning('请至少选择一个部门');
        return;
      }
      this.editBalanceVisible = true;
    },
    // 处理编辑单个部门余额
    handleEditSingleBalance(row) {
      this.selectedDepartments = [{
        id: row.id,
        name: row.name,
        balance: row.balance
      }];
      this.editBalanceVisible = true;
    },
    // 表格选择回调
    selects(selection) {
      this.selectedDepartments = selection.map(item => ({
        id: item.id,
        name: item.name,
        balance: item.balance
      }));
    },
    qryInfo() {
      let data = {};
      data.orgName = this.form.orgName;
      data.orgId = this.currentDepartmentId == null ? '' : this.currentDepartmentId;
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      
      getParkingBalanceList(data)
          .then((res) => {
            this.tableData1 = res.data.data || [];
            this.tableData1.forEach(item => item.parkingBalance /= 100)
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "查询失败", {
              type: "error",
            })
          });
    },
  },
  components: {
    DepartmentTree,
    DataTable,
    EditBalanceDialog,
  },
  mounted() {
    this.qryInfo();
  }
};
</script>

